import get from 'lodash/get';
import { SiteHeaderStoreSlice, SiteHeaderState } from './types';
import { reduxKey } from './constants';
import { initialState } from './reducer';
import { getCurrentStreamId } from '../../Duperbrowse/redux/selectors';
import {
  DAMZ_PAGE_DUPERBROWSE_STREAMID,
  FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
} from '../../Duperbrowse/redux/constants';

export function getSiteHeaderState(
  state: SiteHeaderStoreSlice
): SiteHeaderState {
  return get(state, reduxKey, initialState);
}

export function getIsNotificationsDropdownOpen(state) {
  return getSiteHeaderState(state).isNotificationsDropdownOpen;
}

export function getIsSearchModalShown(state) {
  return getSiteHeaderState(state).isSearchModalShown;
}

export function getIsUserDropdownOpen(state) {
  return getSiteHeaderState(state).isUserDropdownOpen;
}

export function getIsBurgerMenuOpen(state) {
  return getSiteHeaderState(state).isBurgerMenuOpen;
}

export function getIsFeedbackPageOpen(state) {
  return getCurrentStreamId(state) === FEEDBACK_PAGE_DUPERBROWSE_STREAMID;
}

// This is here because we can't import from da-damz-shared here and this is easier than
// passing stuff around.
export function getDamzHeaderCount(state) {
  return state?.['@@DAMZ']?.counter?.conversations ?? 0;
}
// This is here because we can't import from da-damz-shared here and this is easier than
// passing stuff around.
export function getDamzHeaderRequestsCount(state) {
  return state?.['@@DAMZ']?.counter?.requests ?? 0;
}

export function getIsDamzDropdownOpen(state) {
  return getSiteHeaderState(state).isDamzDropdownOpen;
}

export function getIsDamzPageOpen(state) {
  return getCurrentStreamId(state) === DAMZ_PAGE_DUPERBROWSE_STREAMID;
}
